module.exports = __webpack_public_path__ + "static/media/ic_vetc.e83d23de.png";